<div *ngIf="imageCheck" style="height:100%;width:100%;">
  <img [src]="src" style="max-height:100%;max-width:100%;"/>
</div>
<div *ngIf="!imageCheck" style="height:100%;width:100%;background:url(/assets/admin/images/board_img.png) no-repeat 50% 50%;opacity:0.5"></div>

